import { dispatchPromise, fetchResources } from './action-helpers';

import { getActiveProjects, getMilestonesFetched, getMilestonesLoading } from '../services/store-service';
import { createTempId } from '../utils/helpers';

const DEFAULT_MILESTONE_PROPS = {
    start: null,
    end: null,
    id: null,
    name: undefined,
    project: undefined,
    task_group: undefined,
    order: Number.POSITIVE_INFINITY,
    tasks: [],
    statistic: {
        total: 0,
        completed: 0,
        overdue: 0
    }
};

export const createMilestone = milestoneProps => {
    return dispatchPromise({
        type: 'MILESTONE_CREATE_REQUESTED',
        payload: {
            milestone: Object.assign({}, DEFAULT_MILESTONE_PROPS, milestoneProps, {
                id: createTempId()
            })
        }
    });
}

export const fetchAllMilestones = () => {
    return Promise.all(getActiveProjects().map(({ id }) => {
        if (!getMilestonesFetched(id) && !getMilestonesLoading(id)) {
            return fetchMilestones({ projectId: id });
        }

        return Promise.resolve();
    }));
}

export const fetchMilestones = ({ projectId, goalId }: { projectId?: string, goalId?: string }, all) => fetchResources('MILESTONES_FETCH_REQUESTED', { projectId, goalId }, all);

export const fetchMilestone = milestoneId => {
    return dispatchPromise({
        type: 'MILESTONE_FETCH_REQUESTED',
        payload: { milestoneId }
    });
}

export const updateMilestone = (milestoneId, milestoneProps, preventSave) => {
    return dispatchPromise({
        type: 'MILESTONE_UPDATE_REQUESTED',
        preventSave,
        payload: {
            milestoneId,
            milestoneProps
        }
    });
}

export const updateMilestones = (updatePairs, preventSave) => {
    return dispatchPromise({
        type: 'MILESTONES_UPDATE_REQUESTED',
        preventSave,
        payload: {
            updatePairs
        }
    });
}

export const assignMilestone = (milestoneId, assignees) => {
    return dispatchPromise({
        type: 'MILESTONE_ASSIGN_REQUESTED',
        payload: {
            milestoneId,
            assignees
        }
    });
}

export const unassignMilestone = (milestoneId, assignees) => {
    return dispatchPromise({
        type: 'MILESTONE_UNASSIGN_REQUESTED',
        payload: {
            milestoneId,
            assignees
        }
    });
}


export const removeMilestone = milestoneId => {
    return dispatchPromise({
        type: 'MILESTONE_REMOVE_REQUESTED',
        payload: {
            milestoneId
        }
    });
}

export const setMilestoneVisibility = (milestoneId, visible, roles) => {
    return dispatchPromise({
        type: 'MILESTONE_VISIBILITY_SET_REQUESTED',
        payload: {
            milestoneId,
            visible,
            roles
        }
    });
}

export const tieMilestoneTasks = (milestoneId, tasks) => {
    return dispatchPromise({
        type: 'MILESTONE_TIE_TASKS_REQUESTED',
        payload: {
            milestoneId,
            tasks
        }
    });
}

export const untieMilestoneTasks = (milestoneId, tasks) => {
    return dispatchPromise({
        type: 'MILESTONE_UNTIE_TASKS_REQUESTED',
        payload: {
            milestoneId,
            tasks
        }
    });
}

export const moveMilestone = (milestoneId, projectId) => {
    return dispatchPromise({
        type: 'MILESTONE_MOVE_REQUESTED',
        payload: {
            milestoneId,
            projectId
        }
    });
}
